import BadgeId from "../../../components/common/BadgeId";
import useCerokmSourceData from "../../../components/common/react-hooks/useCerokmSourceData";
import LegoContextSummary from "../../../components/lego/LegoContextSummary";
import { stringToColor } from '../../../components/common/colorUtils';

export default function SpecGroupBadge({ id, className = '', large = false }) {
  const groupData = useCerokmSourceData('services/cerokm/specsgroup')(id);

  const hashedColor = (id ? stringToColor(id) : '#000000') + '55';

  const size = 40;

  
  let sourceContent = <div>??</div>;
  if (!groupData) {
    sourceContent = <BadgeId id={id} />;
  } else {
    let { context: { trim, ...restOf }, trimDescription, name } = groupData;
    sourceContent = <div className={"text-center " + (large ? '' : 'zoom-75')}>
      <div><LegoContextSummary context={restOf} inline={true} /> <span className="badge badge-secondary">{trim}</span></div>
      <div className="ml-1 text-secondary small" title={trimDescription}>{name}</div>
    </div>
  }
  
  return <span className={`${large ? 'p-1' : ''} d-inline-flex align-items-center justify-content-center align-middle rounded overflow-hidden border border-light ${className}`}
    title={id}
    key={id}
    style={{ width: large ? 'auto' : '200px', height: large ? 'auto' : (size + 2) + 'px', backgroundColor: hashedColor }}>
    {sourceContent}
  </span>
}
